import React from 'react';
import { LivenOptionQuestion } from './LivenOptionQuestion';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { useTranslation } from 'react-i18next';
import Spacer from 'components/spacer/Spacer';
import i18next from 'i18next';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import { TextOption } from '../options/TextOption';
import { useLivenOptionQuestionLogic } from './LivenOption.hook';
import { OptionIconsMap } from './LivenOptionsIconsMap';
import styles from './styles.module.scss';

type Props = QuestionComponentProps<LivenOptionQuestion>;

export const LivenOptionQuestionComponent: React.FC<Props> = ({
  question,
}: Props) => {
  const { t } = useTranslation();
  const {
    title,
    age,
    gender,
    activeOptions,
    containerStyle,
    optionHandler,
    nextHandler,
  } = useLivenOptionQuestionLogic(question);

  const getOptionText = (option: TextOption) => {
    return i18next.exists(option.text) ? t(option.text) : option.text;
  };

  return (
    <div
      className={`
        ${styles.container} 
        ${styles[containerStyle]} 
        ${styles.speed} 
        ${!question.withIcon ? styles.center : ''}
        maxWidth
      `}
    >
      <h3
        className={`${styles.title} ${
          question.hasStepper ? '' : styles.titleWithMargin
        }`}
      >
        {t(title, { age: t(age), gender: t(gender) })}
      </h3>
      {question?.note && activeOptions.length > 0 && (
        <div className={styles.hintContainer}>
          <div className={styles.title}>
            <p className="app-text p5">💡{question.note.title}</p>
          </div>
          <div className={styles.description}>
            <p>
              <span>{question.note.decription}</span>
            </p>
          </div>
        </div>
      )}
      {question.description && (
        <p className={styles.description}>{t(question.description)}</p>
      )}
      {question.options.map((option) => (
        <button
          key={option.id}
          className={`
            ${styles.option} 
            ${question.multiple ? styles.multiple : ''} 
            ${option.subtext ? styles.withSubText : ''}
            ${activeOptions.includes(option.id) ? styles.active : ''}
          `}
          onClick={optionHandler(option)}
        >
          <div className={styles.contentWrapper}>
            {question.withIcon && (
              <img src={OptionIconsMap[option.id]} alt="" />
            )}{' '}
            {option.subtext ? (
              <>
                <span className={styles.text}>{getOptionText(option)}</span>
                <span className={styles.subtext}>{t(option.subtext)}</span>
              </>
            ) : (
              getOptionText(option)
            )}
          </div>
          {question.multiple && (
            <span
              className={`${styles.marker} ${
                activeOptions.includes(option.id) ? styles.active : ''
              }`}
            />
          )}
        </button>
      ))}
      <Spacer />
      {((question.multiple && activeOptions.length > 0) ||
        (question?.note && activeOptions.length > 0)) && (
        <StickyContainer className={styles.buttonContainer}>
          <button className={styles.button} onClick={nextHandler}>
            {t('Continue')}
          </button>
        </StickyContainer>
      )}
    </div>
  );
};
